import { getDateFullYear } from './getDateFullYear'

export const mutate = (data) => {
	if (!data) {
		return
	}

	let result = []

	const isArray = Array.isArray(data)

	if (isArray) {
		result = processEntries(data)
	} else {
		result = processEntry(data)
	}

	return result
}

const processEntries = (entries) => {
	const result = []

	entries.forEach((entry) => {
		result.push(mutateEntry(entry))
	})

	return result
}

const processEntry = (entry) => {
	const result = []

	result.push(mutateEntry(entry))

	return result
}

const mutateEntry = (entry) => {
	let result = {}
	const artwork = {}

	const {
		fields,
	} = entry

	result.id = entry.sys.id

	for (let field in fields) {
		const isArray = Array.isArray(fields[field])

		// skaters, brands, director, etc
		// get ids and names
		if (isArray) {
			fields[field] = fields[field].map((item) => {
				return {
					id: item.sys.id,
					...item.fields,
				}
			})
		}

		// transform releaseDate, return just the year
		if (field === 'releaseDate') {
			fields[field] = getDateFullYear(fields[field])
		}

		if (field === 'coverImage') {
			if (fields[field].fields) {
				artwork.cover = fields[field].fields.file.url

				delete fields[field]
			}
		}

		if (field === 'featureImage') {
			if (fields[field].fields) {
				artwork.feature = fields[field].fields.file.url

				delete fields[field]
			}
		}

		if (field === 'posterImage') {
			if (fields[field].fields) {
				artwork.poster = fields[field].fields.file.url

				delete fields[field]
			}
		}
	}

	result.artwork = { ...artwork }

	result = Object.assign(result, fields)

	return result
}



// WEBPACK FOOTER //
// ./src/common/contentful/lib/mutate.js